export const codeTemplate = `<iframe
  title="%title%"
  src="%embed_address%/%id%"
  seamless
  width="100%"
  height="700px"
  allow="clipboard-read; clipboard-write"
  class="brand3d-embedded-iframe"
  ></iframe>
  <style>
  .brand3d-embedded-iframe {
    border: none;
    width: 100%;
    /* height: 50vh; /* setting height is optional */
}
</style>`;
